// forum-device-id — forum「最热」随机起始页身份。
// 身份来源:登录用户用其 uuid(getForumIdentity),匿名回退浏览器持久 device token。
// 作为 /gapi/public/forum/hot 的 id 参数,后端据此 + 日期 + 作用域算每日随机起始页。
// 无隐私数据,仅用于把曝光均摊到前 25 页。
import { useAuthStore } from '@dogdisk/shared'

const KEY = 'dogdisk_forum_device_id'

export function getForumDeviceId(): string {
  try {
    const existing = localStorage.getItem(KEY)
    if (existing) return existing
    const id =
      typeof crypto !== 'undefined' && 'randomUUID' in crypto
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`
    localStorage.setItem(KEY, id)
    return id
  } catch {
    // localStorage 不可用(隐私模式等):退化为进程内随机(当天稳定性丢失但不报错)。
    return 'anon'
  }
}

/** 最热起始页身份:登录用户用其 uuid,匿名回退浏览器持久 device token。 */
export function getForumIdentity(): string {
  const uid = useAuthStore.getState().activeUserId
  return uid ?? getForumDeviceId()
}
